/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetRedlineUsageQueryResponse, ReportingControllerGetRedlineUsageQueryParams, ReportingControllerGetRedlineUsage400, ReportingControllerGetRedlineUsage401, ReportingControllerGetRedlineUsage403, ReportingControllerGetRedlineUsage404 } from "../../models/reportingController/ReportingControllerGetRedlineUsage";

function getReportingControllerGetRedlineUsageUrl() {
  const res = { method: 'GET', url: `/api/v1/reporting/redlines` as const }  
  return res
}

/**
 * @summary Get redlining usage for an organization: redlines run, distinct users, a per-team breakdown, a bucketed series and the previous-period comparison. Honors the team and date filters.
 * {@link /api/v1/reporting/redlines}
 */
export async function reportingControllerGetRedlineUsage(params: ReportingControllerGetRedlineUsageQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ReportingControllerGetRedlineUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetRedlineUsage400 | ReportingControllerGetRedlineUsage401 | ReportingControllerGetRedlineUsage403 | ReportingControllerGetRedlineUsage404>, unknown>({ method : "GET", url : getReportingControllerGetRedlineUsageUrl().url.toString(), params, ... requestConfig })  
  return res.data
}